import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-plus",
  "use": "rt-base-plus-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-plus\"><path d=\"M896 468H556V128c0-8.8-7.2-16-16-16h-56c-8.8 0-16 7.2-16 16v340H128c-8.8 0-16 7.2-16 16v56c0 8.8 7.2 16 16 16h340v340c0 8.8 7.2 16 16 16h56c8.8 0 16-7.2 16-16V556h340c8.8 0 16-7.2 16-16v-56c0-8.8-7.2-16-16-16z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/plus.svg
// module id = 1737
// module chunks = 228